export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-agendamento-retroativo' */ '@/views/ambulatorio/agendamento-retroativo/Index'),
        path: 'agendamento-retroativo',
        redirect: 'agendamento-retroativo/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-agendamento-retroativo' */'@/views/ambulatorio/agendamento-retroativo/List.vue'),
                name: 'ambulatorio-agendamento-retroativo-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-agendamento-retroativo' */ '@/views/ambulatorio/agendamento-retroativo/Form.vue'),
                name: 'ambulatorio-agendamento-retroativo-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]